module.exports = {
	config: {
		usage: 'management' // NOTE: 	"management" is used by default (ninja-entity management)
							// 			"selection" is used to select a ninja-entity (e.g., within pickers) instead of editing one.
							//				selection will be set if picker can be found within attach-phase.
	},

	model: {
		entityTable: false,

		ninjaModule: '',            // actual ninjaModule (e.g., news)
		ninjaModuleConfig: {},      // actual ninjaModuleConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.news)
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault()
				event.stopImmediatePropagation()

				const self = event.data.component
				const $target = $(event.target)

				if($target.length > 0){
					const fieldType = $target.data('fieldType')

					if(self.model.entityTable){

						if(fieldType === 'showInsert'){
							self.model.entityTable.showInsert()
						} else if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						}
					}
				}
			}
		},
	},

	methods: {
		getNinjaModuleParams(){
			return {
				ninjaModule: 		this.model.ninjaModule,
				ninjaModuleConfig: 	(this.model.ninjaModuleConfig = ((((((storage || {}).app || {}).webService || {}).containerInfo || {}).config || {}).ninjaModules || {})[this.model.ninjaModule || 'missingNinjaModule'] || {})
			}
		},

		toggleRowSelection: function(rowID, rowData){
			this.triggerFind('toggleRowSelection', {
				rowID,
				rowData
			});
		},

		onBeforeRender(){
			if(this.model.isInPicker === undefined){
				this.model.isInPicker = false
				this.closest('base_form_fields_ninja-picker-button', () => this.model.isInPicker = true)

				if(this.model.isInPicker){
					this.config.usage = 'selection'
				}
			}
		},
	},

	hooks: {
		attach: function($element, options){
			if(!this.model.entityTable){
				this.find('base_tableSimple_table', entityTable => {
					if(!(entityTable.config || {}).isSelectionTarget){
						this.model.entityTable = entityTable
					}
				})
			}
		},

		filtersChanged: function ($element, options) {
			this.triggerFind('filtersChanged', options)
		},

		filterColumnsChanged: function ($element, options) {
			this.triggerFind('filterColumnsChanged', options)
		},

		colTagsBubbleSelected: function($element, options){
			this.triggerFind('colTagsBubbleSelected', options)
		},

		showColumnDescription: function ($element, options) {
			this.triggerFind('showColumnDescription', options)
		},

		hideColumnDescription: function ($element, options) {
			this.triggerFind('hideColumnDescription', options)
		},

		onTableSelectionChanged: function($element, options) {
			this.triggerFind('onTableSelectionChanged', options);
		},
	}
};
